module.exports = __webpack_public_path__ + "static/media/primera_dictadura.f0a28851.md";